// @ts-nocheck
import { Identity } from "@pdfking/tfunc"
import { is_mapping } from "./is_mapping"
import { map } from "./map"
import { ordered_object } from "./ordered_object"
import { scan } from "./scan"

/**
 * Groups iterable by key function.
 *
 * Groups elements by result of key function. For arrays, groups into arrays.
 * For objects, groups into objects. Optional merger combines groups.
 *
 * @param iterable - Array or object to group
 * @param f - Grouping function (default: Identity)
 * @param merger - Optional function to merge grouped values
 * @returns Object with grouped results
 *
 * @example
 * ```ts
 * import { group_by } from "@pdfking/rfunc"
 *
 * group_by([1, 1, 2, 3]) // { 1: [1, 1], 2: [2], 3: [3] }
 * group_by([{ a: 2 }, { a: 3 }], v => v.a) // { 2: [{ a: 2 }], 3: [{ a: 3 }] }
 * group_by([1, 1, 2], v => v, arr => arr.length) // { 1: 2, 2: 1 }
 * ```
 */
const array_assigner = (result, grouper, _k, v) => {
  if (!result[grouper]) {
    result[grouper] = []
  }
  result[grouper].push(v)
}

const mapping_assigner = (result, grouper, k, v) => {
  if (!result[grouper]) {
    result[grouper] = ordered_object()
  }
  result[grouper][k] = v
}

export const group_by = (iterable, f: any = Identity, merger = null) => {
  const assigner = is_mapping(iterable) ? mapping_assigner : array_assigner
  const result = ordered_object()

  scan((v, k) => assigner(result, f(v), k, v), iterable)

  if (merger) {
    return map(merger, result)
  }

  return result
}
